<template>
    <div><p>{{status}}</p></div>
</template>

<script>
    export default {
        name: "recoverConfirm",
        data() {
            return {
                status: 'Chargement ...'
            }
        },
        created() {
            this.$http.get('/recover-password-email?id=' + this.$route.query.id + '&token=' + this.$route.query.token)
                .then(response => {
                    this.$router.push({
                        name: 'recover.edit',
                        params: {id: this.$route.query.id, token: this.$route.query.token}
                    })
                })
                .catch(err => {
                    if (this.$isSignatureExpired(err.response.data.message)) {
                        this.$store.dispatch('logout')
                        this.$router.push({name: 'Login', params: {q: 'expired'}})
                    }
                    this.status = "Votre lien n'est pas valide, veuillez essayer à nouveau"
                })
        }
    }
</script>

<style scoped lang="scss">

</style>
